module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-40-min.68a8cd96.jpg";